'use client';

import { Typography } from '@mui/material';
import { CustomPagination } from '@/components';
import { useTranslations } from 'next-intl';
import { BrokerGrid, EmptyState } from '../../styled';
import { BrokerCard } from '../BrokerCard';
import type { ImpersonatedBroker } from '@/contexts/masterAdmin';

const PAGE_SIZE = 10;

type BrokerListProps = {
  brokers: ImpersonatedBroker[];
  query: string;
  page: number;
  onPageChange: (page: number) => void;
};

export const BrokerList = ({ brokers, query, page, onPageChange }: BrokerListProps) => {
  const t = useTranslations('masterAdmin');

  const paginated = brokers.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  if (brokers.length === 0) {
    return (
      <EmptyState>
        <Typography>
          {t('noResults')} &bdquo;{query}&ldquo;
        </Typography>
      </EmptyState>
    );
  }

  return (
    <>
      <BrokerGrid>
        {paginated.map((broker) => (
          <BrokerCard key={broker.id} broker={broker} />
        ))}
      </BrokerGrid>
      <CustomPagination
        page={page}
        numFound={brokers.length}
        itemsPerPage={PAGE_SIZE}
        onPageChange={(newPage) => {
          onPageChange(newPage);
          window.scrollTo({ top: 0 });
        }}
      />
    </>
  );
};
